import angular from 'angular';

import PolicyDirective from './policy.directive';

const PolicyModule = angular
    .module('control-room.commons.basic.directives.policy', [])
    .directive('crPolicy', PolicyDirective.directiveFactory);

export default PolicyModule;
